function escapeHtml (value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * HTML do modal de confirmação "marcar como pago" (SweetAlert2).
 */
export function buildMarcarPagoSwalHtml ({ cliente, valor, vencimento, labels }) {
  const vencRow = vencimento
    ? `
      <div class="ws-fin-swal__row">
        <span class="ws-fin-swal__label">${escapeHtml(labels.vencimento)}</span>
        <span class="ws-fin-swal__value">${escapeHtml(vencimento)}</span>
      </div>`
    : ''

  return `
    <div class="ws-fin-swal">
      <div class="ws-fin-swal__icon" aria-hidden="true">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <h2 class="ws-fin-swal__title">${escapeHtml(labels.title)}</h2>
      <p class="ws-fin-swal__subtitle">${escapeHtml(labels.subtitle)}</p>
      <div class="ws-fin-swal__card">
        <div class="ws-fin-swal__row">
          <span class="ws-fin-swal__label">${escapeHtml(labels.cliente)}</span>
          <span class="ws-fin-swal__value ws-fin-swal__value--name">${escapeHtml(cliente)}</span>
        </div>
        <div class="ws-fin-swal__row ws-fin-swal__row--valor">
          <span class="ws-fin-swal__label">${escapeHtml(labels.valor)}</span>
          <span class="ws-fin-swal__value ws-fin-swal__value--money">${escapeHtml(valor)}</span>
        </div>
        ${vencRow}
      </div>
    </div>
  `
}

export const MARCAR_PAGO_SWAL_CLASS = {
  popup: 'ws-fin-swal-popup',
  htmlContainer: 'ws-fin-swal-html',
  actions: 'ws-fin-swal-actions',
  confirmButton: 'ws-fin-swal-btn ws-fin-swal-btn--confirm',
  cancelButton: 'ws-fin-swal-btn ws-fin-swal-btn--cancel',
  closeButton: 'ws-fin-swal-close'
}
